import React, { useEffect } from "react";
import useAxiosInterceptors from "./common/useAxiosInterceptors";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./components/header/Header";
import Sidepanel from "./components/sidepanel/Sidepanel";
import Premises from "./screens/Premises/Premises";
// import FsDashboard from "./screens/FsDashboard/FsDashboard";
import Dashboard from "./screens/Dashboard/Dashboard";
import Login from "./screens/Login/Login";
import { useAuth } from "./auth/AuthProvider";
import PrivateRoute from "./auth/PrivateRoute";
import { useSidenavStore } from "./store/store";
// import Tasks from "./screens/Tasks/Tasks";
// import PoliciesAndManuals from "./screens/PoliciesAndManuals/PoliciesAndManuals";
import AddPremises from "./screens/AddPremises/Addpremises";
import Allmodules from "./screens/AddPremises/Allmodules";
import PremisesModules from "./screens/AddPremises/PremisesModule";
// import RiskAssess from "./screens/RiskAssessment/RiskAssess";
// import Budgeting from "./screens/Budgeting/Budgeting";
import CreateBudgeting from "./screens/Budgeting/CreateBudgeting";
// import FolderView from "./screens/PoliciesAndManuals/FolderView";
// import FireSafteyIncident from "./screens/IncidentManagement/FireSafetyIncident";
// import IMDashboard from "./screens/IncidentManagement/IMDashboard";
// import Incidents from "./screens/IncidentManagement/Incidents";
// import Report from "./screens/IncidentManagement/Reports";
// import SafetyEquipment from "./screens/SafetyEquipment/SafetyEquipment";
// import AddAssets from "./screens/SafetyEquipment/AddAssets";
import ResetPassword from "./screens/ResetPassword/ResetPassword";
// import TrainingDashboard from "./screens/StaffTrainingAndPlan/TrainingDashboard";
// import UpcomingSessions from "./screens/StaffTrainingAndPlan/UpcomingSessions";
// import UpcomingSessionDetails from "./screens/StaffTrainingAndPlan/UpcomingSessionDetails";
// import PastEvaluation from "./screens/StaffTrainingAndPlan/PastEvaluation";
// import PastEvaluationDetails from "./screens/StaffTrainingAndPlan/PastEvaluationDetails";
// import CreateTraining from "./screens/StaffTrainingAndPlan/CreateTraining";
// import CreateTest from "./screens/StaffTrainingAndPlan/CreateTest";
// import StartTest from "./screens/StaffTrainingAndPlan/StartTest";
import Regions from "./screens/Regions/Regions";
import UpdateRegion from "./screens/Regions/UpdateRegion";
import Departments from "./screens/Departments/Departments";
import RoleManagement from "./screens/RoleManagement/RoleManagement";
import UserManagement from "./screens/UserManagement/UserManagement";
// import FireDrills from "./screens/FireDrills/FireDrills";
import { proxyUrl } from "./common/utils";
import BudgetCategories from "./screens/Budgeting/BudgetCategories/BudgetCategories";
import PolicyTags from "./screens/PoliciesAndManuals/PolicyTags";
import FireRiskProcesses from "./screens/FireRiskProcesses/FireRiskProcesses";
import FireRiskSubProcesses from "./screens/FireRiskProcesses/FireRiskSubProcesses";
import LegalContractTypes from "./screens/ContractTypes/LegalContractTypes";
import Audits from "./screens/FireSafetyAudits/Audits";
import CheckList from "./screens/FireSafetyAudits/CheckList";
import CreateCheckList from "./screens/FireSafetyAudits/CreateCheckList";

import PermissionWrapper from "./components/PermissionWrapper/PermissionWrapper";
import Unauthorized from "./components/Unauthorized/Unauthorized";
import FireSystemEntry from "./components/DashboardModules/FireSystemsEntry";
// import { ProtectedRoute } from "./components/ProtectedRoutes/ProtectedRoute";
import protectedRoutes from "./routeConfigs";
import IncidentSystemEntry from "./components/DashboardModules/IncidentSystemEntry";
import TenantManagement from "./screens/Organization/TenantManagement";
import ViewCheckList from "./screens/FireSafetyAudits/ViewCheckList";
import PerformCheckList from "./screens/FireSafetyAudits/PerformCheckList";
import Equipment from "./screens/MastarData/EquipmentInventory/Equipment";
import AssetEquipmentSubcategory from "./screens/MastarData/EquipmentInventory/AssetEquipmentSubcategory";
import WashroomManagementEntry from "./components/DashboardModules/WashroomManagementEntry";
import PoliciesAndManuals from "./screens/PoliciesAndManuals/PoliciesAndManuals";
import FolderView from "./screens/PoliciesAndManuals/FolderView";
import {
  hazardousMaterialsConfig,
  lawsAndRegulationsConfig,
} from "./screens/PoliciesAndManuals/policiesConfig";
import LawsAndRegulationsAudit from "./screens/LawsAndRegulations/LawsAndRegulationsAudit/LawsAndRegulationsAudit";
import LawsAndRegulationsTask from "./screens/LawsAndRegulations/LawsAndRegulationsTask/LawsAndRegulationsTask";
import FacilityInformation from "./screens/LawsAndRegulations/FacilityInformation/FacilityInformation";
import PremisesInformationView from "./screens/LawsAndRegulations/FacilityInformation/PremisesInformationView";
import StaffManagement from "./screens/LawsAndRegulations/StaffManagement/StaffManagement";
import LawsAndRegulationsDashboard from "./screens/LawsAndRegulations/LawsAndRegulationsDashboard/LawsAndRegulationsDashboard";
import WashroomDashboard from "./screens/WashroomManagement/WashroomsDashboard/WashroomDashboard";
import WashroomMaintenance from "./screens/WashroomManagement/WashroomMaintenance/WashroomMaintenance";
import WashroomChecklists from "./screens/WashroomManagement/WashroomChecklists/WashroomChecklists";
import ChecklistConfigForm from "./screens/WashroomManagement/WashroomChecklists/ChecklistConfigForm";
import AddWashroom from "./screens/WashroomManagement/WashroomMaintenance/AddWashroom";
import WashroomReports from "./screens/WashroomManagement/WashroomReports/WashroomReports";
import WashroomAudits from "./screens/WashroomManagement/WashroomAudits/WashroomAudits";
import WashroomChecklistCategory from "./screens/WashroomManagement/WashroomChecklists/WashroomChecklistCategory/WashroomChecklistCategory";
import AuditList from "./screens/WashroomManagement/WashroomAudits/AuditList";
import WashroomStatus from "./screens/WashroomManagement/WashroomMaintenance/WashroomStatus";
// import WashroomIssuesList from "./screens/WashroomManagement/WashroomIssues/WashroomIssuesList";
import AuditHistory from "./screens/WashroomManagement/WashroomAudits/AuditHistory";
import WashroomManagementIncident from "./screens/IncidentManagement/WashroomManagementIncident";
import EquipmentManagementEntry from "./components/DashboardModules/EquipmentManagementEntry";
import HazardousMaterialManageEntry from "./components/DashboardModules/HazardousMaterialManageEntry";
import EquipmentCategory from "./screens/MasterDataCats/EquipmentCategory/EquipmentCategory";
import EquipmentSubCategory from "./screens/MasterDataCats/EquipmentSubCategory/EquipmentSubCategory";
import ManufacturerList from "./screens/MasterDataCats/ManufacturerList/ManufacturerList";
// import VendorMaster from "./screens/MasterDataCats/VendorMaster/VendorMaster";
import LocationMaster from "./screens/MasterDataCats/LocationMaster/LocationMaster";
import MaintenanceTypeList from "./screens/MasterDataCats/MaintenanceTypeList/MaintenanceTypeList";
import MaterialInventoryManagement from "./screens/HazardousMaterialManagement/MaterialInventory/MaterialInventoryManagement";
import SafetyAndComplianceInfo from "./screens/HazardousMaterialManagement/SafetyAndComplianceInfo/SafetyAndComplianceInfo";
import StorageHandlingRecords from "./screens/HazardousMaterialManagement/StorageAndHandlingRecords/StorageAndHandlingRecords";
import TrackingAndMovementLogs from "./screens/HazardousMaterialManagement/TrackingAndMovementLogs/TrackingAndMovementLogs";
import IncidentAndSpillReports from "./screens/HazardousMaterialManagement/IncidentAndSpillReports/IncidentAndSpillReports";
import InspectionComplianceChecks from "./screens/HazardousMaterialManagement/InspectionAndCompliance/InspectionAndCompliance";
import DisposalManagement from "./screens/HazardousMaterialManagement/DisposalManagement/DisposalManagement";
import SearchAndReporting from "./screens/HazardousMaterialManagement/SearchAndReporting/SearchAndReporting";
import TrainingModuleLayout from "./screens/StaffTrainingAndPlan/TrainingModuleLayout";
import {
  HAZARDOUS_MATERIALS_TRAINING_CONFIG,
  EQUIPMENT_MANAGEMENT_TRAINING_CONFIG,
  EXTERNAL_EMERGENCY_PREPAREDNESS_TRAINING_CONFIG,
} from "./screens/StaffTrainingAndPlan/moduleConfigs";
import TrainingDashboard from "./screens/StaffTrainingAndPlan/TrainingDashboard";
import UpcomingSessions from "./screens/StaffTrainingAndPlan/UpcomingSessions";
import UpcomingSessionDetails from "./screens/StaffTrainingAndPlan/UpcomingSessionDetails";
import PastEvaluation from "./screens/StaffTrainingAndPlan/PastEvaluation";
import PastEvaluationDetails from "./screens/StaffTrainingAndPlan/PastEvaluationDetails";
import CreateTraining from "./screens/StaffTrainingAndPlan/CreateTraining";
import CreateTest from "./screens/StaffTrainingAndPlan/CreateTest";
import StartTest from "./screens/StaffTrainingAndPlan/StartTest";
import AttemptTest from "./screens/StaffTrainingAndPlan/AttemptTest";
import TrainingView from "./screens/StaffTrainingAndPlan/TrainingView";
import UserTrainingAnalytics from "./screens/StaffTrainingAndPlan/UserTrainingAnalytics";
import TrainerStartTest from "./screens/StaffTrainingAndPlan/TrainerStartTest";
import SupplierData from "./screens/MasterDataCats/SuppliersData/SupplierData";
import IncidentSeverityLevels from "./screens/MasterDataCats/IncidentSeverityLevels/IncidentSeverityLevels";
import HazardMaterialCategory from "./screens/MasterDataCats/HazardMaterialCategory/HazardMaterialCategory";
import DisposalMethods from "./screens/MasterDataCats/DisposalMethodsList/DisposalMethods";
import UnitsofMeasureList from "./screens/MasterDataCats/UnitsofMeasureList/UnitsofMeasureList";
import UtilitySystemsEntry from "./components/DashboardModules/UtilitySystemsEntry";
import ExternalEmergencyPreparednessEntry from "./components/DashboardModules/ExternalEmergencyPreparednessEntry";
import SafetyFacilityRoundsEntry from "./components/DashboardModules/SafetyFacilityRoundsEntry";
import SecurityManagementEntry from "./components/DashboardModules/SecurityManagementEntry";
// import EditProfile from "./components/Profile/EditProfile";
import ForgotPassword from "./screens/Login/ForgotPassword";
import ResetPassForForgotPassword from "./screens/Login/ResetPassForForgotPassword";
import WashroomTypeList from "./screens/MasterDataCats/WashroomTypeList/WashroomTypeList";
import HazMatChecklistMgmt from "./screens/HazardousMaterialManagement/HazMatChecklistMgmt/HazMatChecklistMgmt";
import HazMatChecklistCategory from "./screens/HazardousMaterialManagement/HazMatChecklistMgmt/HazMatChecklistCategory/HazMatChecklistCategory";
import FireDrills from "./screens/FireDrills/FireDrills";
import RiskAssess from "./screens/RiskAssessment/RiskAssess";
import HazardousWaste from "./screens/HazardousMaterialManagement/HazardousWaste/HazardousWaste";
import ComplianceType from "./screens/MasterDataCats/Compliance Types/ComplianceType";
import EmergencyCategory from "./screens/MasterDataCats/EmergencyCategory/EmergencyCategory";
import EmergencySubCategory from "./screens/MasterDataCats/EmergencySubCategory/EmergencySubCategory";

const MainApp: React.FC = () => {
  const { isNav } = useSidenavStore();
  const { isAuthenticated, loading } = useAuth();
  useAxiosInterceptors(); // Ensures Axios is configured within the React tree

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // useEffect(() => {
  //   const cachedSeed = sessionStorage.getItem("seed");
  //   const expires = Number(sessionStorage.getItem("seed_expires")) || 0;
  //   const now = Date.now();

  //   if (!cachedSeed || now > expires) {
  //     fetch(`${proxyUrl()}/api/permission-seed`)
  //       .then((res) => res.json())
  //       .then((data) => {
  //         sessionStorage.setItem("seed", JSON.stringify(data));
  //         sessionStorage.setItem("seed_expires", String(now + 3000)); // 3600000 // 1 hour TTL
  //       })
  //       .catch((e) => {
  //         console.error("Error loading permission seed:", e);
  //         // sessionStorage.removeItem("seed");
  //         // sessionStorage.removeItem("seed_expires");
  //       });
  //   }
  // }, []);

  return (
    <>
      <div className={`app ${!isNav ? "is-folded" : ""}`}>
        <div className="layout">
          {!loading && isAuthenticated && <Header />}
          {!loading && isAuthenticated && <Sidepanel />}
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route
              path="reset-password-with-token"
              element={<ResetPassForForgotPassword />}
            />
            <Route
              path="/hazardous-material-management/checklist-mgmt"
              element={<HazMatChecklistMgmt />}
            />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route element={<PrivateRoute />}>
              {/* /////////////Module Entry Routes//// */}
              <Route path="/fire-system" element={<FireSystemEntry />} />
              <Route
                path="/washroom-management"
                element={<WashroomManagementEntry />}
              />
              <Route
                path="/fire-safety-incident-admin"
                element={<IncidentSystemEntry />}
              />
              <Route
                path="/equipment-management"
                element={<EquipmentManagementEntry />}
              />
              <Route
                path="/hazardous-materials-module"
                element={<HazardousMaterialManageEntry />}
              />
              <Route
                path="/utility-systems-module"
                element={<UtilitySystemsEntry />}
              />
              <Route
                path="/external-emergency-preparedness-module"
                element={<ExternalEmergencyPreparednessEntry />}
              />
              <Route
                path="/safety-facility-rounds-module"
                element={<SafetyFacilityRoundsEntry />}
              />
              <Route
                path="/security-module"
                element={<SecurityManagementEntry />}
              />

              {/* /////////////Sub-Module Entry Routes//// */}

              <Route
                path="/washroom-management/dashboard"
                element={<WashroomDashboard />}
              />
              <Route
                path="/washroom-management/washrooms"
                element={<WashroomMaintenance />}
              />
              <Route
                path="/washroom-management/washrooms/add-washroom"
                element={<AddWashroom />}
              />
              <Route
                path="/washroom-management/washrooms/view-washroom"
                element={<AddWashroom />}
              />
              <Route
                path="/washroom-management/washrooms/update-washroom"
                element={<AddWashroom />}
              />
              <Route
                path="/washroom-management/checklists"
                element={<WashroomChecklists />}
              />

              <Route
                path="/washroom-management/washrooms/update-status/:id"
                element={<WashroomStatus />}
              />
              <Route
                path="/washroom-management/checklists/create"
                element={<ChecklistConfigForm />}
              />
              <Route
                path="/washroom-management/checklists/edit/:id"
                element={<ChecklistConfigForm />}
              />
              <Route
                path="/washroom-management/checklists/view/:id"
                element={<ChecklistConfigForm />}
              />
              <Route
                path="/washroom-management/reports"
                element={<WashroomReports />}
              />
              <Route
                path="/washroom-checklist-category"
                element={<WashroomChecklistCategory />}
              />
              {/*               <Route
                path="/washroom-management/issues-reports"
                element={<WashroomIssuesList />}
              /> */}
              <Route
                path="/washroom-management/audits"
                element={<AuditList />}
              />
              <Route
                path="/washroom-management/audits/view/:auditId"
                element={<WashroomAudits />}
              />
              <Route
                path="/washroom-management/audits/history"
                element={<AuditHistory />}
              />
              <Route
                path="/washroom-management/issues-reports"
                element={<WashroomManagementIncident />}
              />

              {/* Laws & Regulations Routes */}
              <Route
                path="/laws-regulations"
                element={<LawsAndRegulationsDashboard />}
              />
              <Route
                path="/laws-regulations-policies"
                element={<PoliciesAndManuals config={lawsAndRegulationsConfig} />}
              />
              <Route
                path="/law-folder/:id"
                element={<FolderView config={lawsAndRegulationsConfig} />}
              />
              <Route
                path="/laws-regulations-audit"
                element={<LawsAndRegulationsAudit />}
              />
              <Route
                path="/laws-regulations-tasks"
                element={<LawsAndRegulationsTask />}
              />
              <Route
                path="/facility-information"
                element={<FacilityInformation />}
              />
              <Route
                path="/premises-information-view"
                element={<PremisesInformationView />}
              />

              <Route path="/staff-management" element={<StaffManagement />} />

              <Route
                path="/washroom-types-list"
                element={<WashroomTypeList />}
              />

              <Route
                path="/equipment-category"
                element={<EquipmentCategory />}
              />
              <Route
                path="/equipment-subcategory"
                element={<EquipmentSubCategory />}
              />
              <Route
                path="/emergency-category"
                element={<EmergencyCategory />}
              />
              <Route
                path="/emergency-subcategory"
                element={<EmergencySubCategory />}
              />
              <Route
                path="/manufacturers-list"
                element={<ManufacturerList />}
              />
              {/* <Route path="/vendor-list" element={<VendorMaster />} /> */}
              <Route path="/vendor-list" element={<SupplierData />} />
              <Route path="/location-master" element={<LocationMaster />} />
              <Route
                path="/maintenancetype-list"
                element={<MaintenanceTypeList />}
              />
              <Route
                path="/unit-of-measure-list"
                element={<UnitsofMeasureList />}
              />
              <Route
                path="/incident-severity-levels"
                element={<IncidentSeverityLevels />}
              />
              <Route
                path="/hazard-material-category"
                element={<HazardMaterialCategory />}
              />
              <Route
                path="/disposal-methods-list"
                element={<DisposalMethods />}
              />
              <Route path="/compliance-types" element={<ComplianceType />} />
              <Route
                path="/hazardous-materials/inventory"
                element={<MaterialInventoryManagement />}
              />
              <Route
                path="/hazardous-materials/safety-compliance-info"
                element={<SafetyAndComplianceInfo />}
              />
              <Route
                path="/hazardous-materials/storage-records"
                element={<StorageHandlingRecords />}
              />
              <Route
                path="/hazardous-materials/tracking-logs"
                element={<TrackingAndMovementLogs />}
              />
              <Route
                path="/hazardous-materials/spill-reporting"
                element={<IncidentAndSpillReports />}
              />
              <Route
                path="/hazardous-materials/inspections/*"
                element={<InspectionComplianceChecks />}
              />
              <Route
                path="/hazardous-materials/inspection-checks"
                element={<InspectionComplianceChecks />}
              />
              <Route
                path="/hazardous-materials/disposal-management"
                element={<DisposalManagement />}
              />
              <Route
                path="/hazardous-materials/waste-tracking"
                element={<HazardousWaste />}
              />
              <Route
                path="/hazardous-materials/search-reporting"
                element={<SearchAndReporting />}
              />
              <Route
                path="/hazardous-materials/checklist-categories"
                element={<HazMatChecklistCategory />}
              />
              <Route
                path="/hazardous-materials/checklists/*"
                element={<HazMatChecklistMgmt />}
              />
              <Route
                path="/hazardous-materials/policies-manuals"
                element={<PoliciesAndManuals config={hazardousMaterialsConfig} />}
              />
              <Route
                path="/hazardous-materials/policies-manuals/folder/:id"
                element={<FolderView config={hazardousMaterialsConfig} />}
              />
              <Route
                path="/hazardous-materials/testing-drills"
                element={<FireDrills />}
              />
              <Route
                path="/hazardous-materials/risk-assessment"
                element={<RiskAssess />}
              />
              <Route
                path="/hazardous-materials/staff-training-evaluation/*"
                element={
                  <PermissionWrapper
                    module={HAZARDOUS_MATERIALS_TRAINING_CONFIG.rbacModule}
                    action="read"
                  >
                    <TrainingModuleLayout
                      config={HAZARDOUS_MATERIALS_TRAINING_CONFIG}
                    />
                  </PermissionWrapper>
                }
              >
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<TrainingDashboard />} />
                <Route
                  path="upcoming-sessions"
                  element={<UpcomingSessions />}
                />
                <Route
                  path="upcoming-sessions/:id"
                  element={<UpcomingSessionDetails />}
                />
                <Route path="past-evaluations" element={<PastEvaluation />} />
                <Route
                  path="past-evaluations/:id"
                  element={<PastEvaluationDetails />}
                />
                <Route
                  path="trainings/create"
                  element={<CreateTraining mode="create" />}
                />
                <Route
                  path="trainings/:id/edit"
                  element={<CreateTraining mode="edit" />}
                />
                <Route
                  path="trainings/:id/view"
                  element={<CreateTraining mode="view" />}
                />
                <Route
                  path="training-view/:id"
                  element={<TrainingView mode="view" />}
                />
                <Route path="start-test/:id" element={<StartTest />} />
                <Route
                  path="create-test"
                  element={<CreateTest mode="create" />}
                />
                <Route path="attempt-test/:id" element={<AttemptTest />} />
                <Route
                  path="trainer-start-test"
                  element={<TrainerStartTest />}
                />
                <Route
                  path="user-analytics"
                  element={<UserTrainingAnalytics />}
                />
              </Route>

              <Route
                path="/equipment-management/staff-training-evaluation/*"
                element={
                  <PermissionWrapper
                    module={EQUIPMENT_MANAGEMENT_TRAINING_CONFIG.rbacModule}
                    action="read"
                  >
                    <TrainingModuleLayout
                      config={EQUIPMENT_MANAGEMENT_TRAINING_CONFIG}
                    />
                  </PermissionWrapper>
                }
              >
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<TrainingDashboard />} />
                <Route
                  path="upcoming-sessions"
                  element={<UpcomingSessions />}
                />
                <Route
                  path="upcoming-sessions/:id"
                  element={<UpcomingSessionDetails />}
                />
                <Route path="past-evaluations" element={<PastEvaluation />} />
                <Route
                  path="past-evaluations/:id"
                  element={<PastEvaluationDetails />}
                />
                <Route
                  path="trainings/create"
                  element={<CreateTraining mode="create" />}
                />
                <Route
                  path="trainings/:id/edit"
                  element={<CreateTraining mode="edit" />}
                />
                <Route
                  path="trainings/:id/view"
                  element={<CreateTraining mode="view" />}
                />
                <Route
                  path="training-view/:id"
                  element={<TrainingView mode="view" />}
                />
                <Route path="start-test/:id" element={<StartTest />} />
                <Route
                  path="create-test"
                  element={<CreateTest mode="create" />}
                />
                <Route path="attempt-test/:id" element={<AttemptTest />} />
                <Route
                  path="trainer-start-test"
                  element={<TrainerStartTest />}
                />
                <Route
                  path="user-analytics"
                  element={<UserTrainingAnalytics />}
                />
              </Route>

              <Route
                path="/external-emergency-preparedness/staff-training-evaluation/*"
                element={
                  <PermissionWrapper
                    module={
                      EXTERNAL_EMERGENCY_PREPAREDNESS_TRAINING_CONFIG.rbacModule
                    }
                    action="read"
                  >
                    <TrainingModuleLayout
                      config={EXTERNAL_EMERGENCY_PREPAREDNESS_TRAINING_CONFIG}
                    />
                  </PermissionWrapper>
                }
              >
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<TrainingDashboard />} />
                <Route
                  path="upcoming-sessions"
                  element={<UpcomingSessions />}
                />
                <Route
                  path="upcoming-sessions/:id"
                  element={<UpcomingSessionDetails />}
                />
                <Route path="past-evaluations" element={<PastEvaluation />} />
                <Route
                  path="past-evaluations/:id"
                  element={<PastEvaluationDetails />}
                />
                <Route
                  path="trainings/create"
                  element={<CreateTraining mode="create" />}
                />
                <Route
                  path="trainings/:id/edit"
                  element={<CreateTraining mode="edit" />}
                />
                <Route
                  path="trainings/:id/view"
                  element={<CreateTraining mode="view" />}
                />
                <Route
                  path="training-view/:id"
                  element={<TrainingView mode="view" />}
                />
                <Route path="start-test/:id" element={<StartTest />} />
                <Route
                  path="create-test"
                  element={<CreateTest mode="create" />}
                />
                <Route path="attempt-test/:id" element={<AttemptTest />} />
                <Route
                  path="trainer-start-test"
                  element={<TrainerStartTest />}
                />
                <Route
                  path="user-analytics"
                  element={<UserTrainingAnalytics />}
                />
              </Route>

              {/* /////////////Sub-Module Entry Routes//// */}
              {protectedRoutes.map(
                ({
                  path,
                  module,
                  component: Component,
                  action,
                  routeProps,
                }) => (
                  <Route
                    key={path}
                    path={path}
                    element={
                      <PermissionWrapper module={module} action={action}>
                        {/* <Component /> */}
                        {React.createElement(Component, routeProps)}
                      </PermissionWrapper>
                    }
                  />
                ),
              )}
              {/* /////////////Sub-Module Entry Routes//// */}

              <Route path="/regions" element={<Regions />} />
              <Route path="/regions/add-region" element={<UpdateRegion />} />
              <Route
                path="/regions/update-region/:id"
                element={<UpdateRegion />}
              />
              <Route
                path="/regions/view-region/:id"
                element={<UpdateRegion />}
              />
              <Route path="/departments" element={<Departments />} />
              <Route path="/asset-equipment-category" element={<Equipment />} />
              <Route
                path="/asset-equipment-subcategory"
                element={<AssetEquipmentSubcategory />}
              />

              <Route
                path="/role-management/roles"
                element={<RoleManagement />}
              />
              <Route
                path="/user-management/roles"
                element={<UserManagement />}
              />

              <Route path="/tenant-management" element={<TenantManagement />} />

              <Route path="/premises" element={<Premises />} />
              <Route path="/dashboard" element={<Dashboard />} />

              <Route path="/add-premises" element={<AddPremises />} />
              <Route path="/add-premises/modules" element={<Allmodules />} />
              <Route path="/update-premises/:id" element={<AddPremises />} />
              <Route
                path="/add-premises/modules/premises-modules"
                element={<PremisesModules />}
              />
              <Route
                path="/update-premises/modules/:id"
                element={<Allmodules />}
              />
              <Route
                path="/update-premises/modules/premises-modules/:id"
                element={<PremisesModules />}
              />
              {/* view */}

              <Route path="/view-premises/:id" element={<AddPremises />} />
              <Route
                path="/view-premises/modules/premises-modules"
                element={<PremisesModules />}
              />
              <Route
                path="/view-premises/modules/:id"
                element={<Allmodules />}
              />
              <Route
                path="/view-premises/modules/premises-modules/:id"
                element={<PremisesModules />}
              />

              <Route
                path="/create-budgeting"
                element={<CreateBudgeting mode="create" />}
              />
              <Route
                path="/view-budgeting/:id"
                element={<CreateBudgeting mode="view" />}
              />
              <Route
                path="/update-budgeting/:id"
                element={<CreateBudgeting mode="update" />}
              />
              <Route path="/policy-tags" element={<PolicyTags />} />
              <Route
                path="/firerisk-processes"
                element={<FireRiskProcesses />}
              />
              <Route
                path="/firerisk-sub-processes"
                element={<FireRiskSubProcesses />}
              />
              <Route
                path="/legal-contract-types"
                element={<LegalContractTypes />}
              />
              <Route path="/fires-safety-audits" element={<Audits />} />
              <Route path="/perform-audits" element={<Audits />} />
              <Route
                path="/perform-audits/check-list"
                element={<PerformCheckList />}
              />
              <Route
                path="/fire-safety-audits/check-list"
                element={<CheckList />}
              />
              <Route
                path="/fire-safety-audits/create-check-list"
                element={<CreateCheckList />}
              />
              <Route
                path="/fire-safety-audits/view-check-list"
                element={<ViewCheckList />}
              />
              <Route
                path="/hazardous-materials/fires-safety-audits"
                element={<Audits />}
              />
              <Route
                path="/hazardous-materials/audits/perform-audits"
                element={<Audits />}
              />
              <Route
                path="/hazardous-materials/perform-audits/check-list"
                element={<PerformCheckList />}
              />
              <Route
                path="/hazardous-materials/audits/check-list"
                element={<CheckList />}
              />
              <Route
                path="/hazardous-materials/audits/create-check-list"
                element={<CreateCheckList />}
              />
              <Route
                path="/hazardous-materials/audits/view-check-list"
                element={<ViewCheckList />}
              />
              <Route path="/budget-categories" element={<BudgetCategories />} />

              <Route path="/*" element={<Navigate to="/dashboard" />} />
            </Route>
          </Routes>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        style={{ zIndex: 99999 }}
      />
    </>
  );
};

export default MainApp;
